export default __webpack_public_path__ + "static/media/signup-button-hover.7d993663.png";